import { Component, ChangeDetectorRef ,Renderer2} from "@angular/core";
import {
  NavigationEnd,
  NavigationStart,
  Router,
  ActivatedRoute,
  Params,
} from "@angular/router";
import { OnboardingService } from "./services/rest/onboarding.service";
import { SharedService } from "./services/shared/shared.service";
import { UtilsService } from "./utils/utils.service";
import { Investor } from "./models/investor";
import { InvestorDetails } from "./models/investor-details";
import { Subject, Subscription } from "rxjs";
import { environment } from "src/environments/environment";
/** ga */
declare var ga: any;
/** Digio */
declare var Digio: any;

/** Angular Component */
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  /** Title for App */
  title: string;
  /** Configuration for component*/
  config: any;
  /** language query param */
  langQueryParam: any = "en";
  /** Screen Data */
  screenData: any;
  /** define Event URL */
  eventURL: any;
  /** Subject */
  subject2 = new Subject<any>();
  /** instance of Subscription*/
  subscription: Subscription;
 
  /**
   * Method to initialize Component
   * @param utils instance of UtilsService
   * @param shared instance of SharedService
   * @param rest instance of OnboardingService
   * @param route instance of Router
   * @param activatedRoute instance of ActivatedRoute
   * @param cdref instance of ChangeDetectorRef
   * @param renderer  instance of Renderer2
   */
  constructor(
    public utils: UtilsService,
    public shared: SharedService,
    public rest: OnboardingService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private cdref: ChangeDetectorRef,
    private renderer : Renderer2
  ) {
    location.hostname !== "localhost" ? (console.log = () => {}) : "";
    location.hostname !== "localhost" ? (console.warn = () => {}) : "";
    this.config = {
      isSkip: true,
      isSupport: true,
      isBack: this.utils.isMobileDevice() && !this.utils.getIPVOnMobileCheck(),
      isModuleStart: false,
    };
    this.screenData = [];
    this.eventURL = "";
    this.loadScript("https://app.digio.in/sdk/v11/digio.js");
    // this.loadScript('https://es9-g8way-dem0.digio.in/sdk/v9/digio.js');
    this.initiateSessionExpiryChecker();
  }
/** clean-up, invoked immediately before a directive, pipe, or service instance is destroyed. */
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.utils.updateOnboardingData(null);
    this.utils.updateModificationData(null);
    this.utils.clearStep();
    this.utils.removeReferCode();
    this.utils.removeSource();
    this.utils.removeOtpConfig();
    this.utils.removeOnboardingData();
    // localStorage.removeItem('isDirectMFPorting');
    // localStorage.removeItem('JFUserName');
    // localStorage.removeItem('JFSession');
    // localStorage.removeItem('JFClientId');
    this.utils.clearSessionStorageKey("isDirectMFPorting");
    this.utils.clearSessionStorageKey("JFUserName");
    this.utils.clearSessionStorageKey("JFSession");
    this.utils.clearSessionStorageKey("JFClientId");
    this.subscription.unsubscribe();
  }
/** runs every time the children nested inside the component (its content) have been checked for changes */
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  /** Life Cycle hook  after initialized all data-bound properties */
  ngOnInit(): void {
    // if (location.hostname.indexOf('accounts.choiceindia.com') > -1) {
    //   this.gtmtrigger();
    //   this.addGoogleTagManagerNoscript()
    //   this.addGoogleAnalyticsScript();
    // }
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.utils.getIP();
    this.checkForOTPForm();
    window.addEventListener("online", () => {
      if (navigator.onLine) {
        this.utils.getIP();
      }
    });

    this.route.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        console.log(!(event.url.indexOf("document-uploads") > -1), event.url);
        this.config.isModuleStart =
          !(event.url.indexOf("document-uploads") > -1) ||
          !(event.url.indexOf("review") > -1);
      } else if (event instanceof NavigationEnd) {
        this.config.isModuleStart = false;
        let businessUnit = this.utils.getBusinessUnit();
        if (opener)
          opener.postMessage(
            JSON.stringify({ url: event.urlAfterRedirects }),
            "*"
          );
        if (parent)
          parent.postMessage(
            JSON.stringify({ url: event.urlAfterRedirects }),
            "*"
          );
        this.utils.modalConfig = false;
        this.config = {
          isSkip: businessUnit == "MF",
          isSupport: true,
          isBack:
            this.utils.isMobileDevice() && !this.utils.getIPVOnMobileCheck(),
        };
        if (
          event.urlAfterRedirects.indexOf("/support") == -1 &&
          event.urlAfterRedirects.indexOf("/walkthrough") == -1 &&
          event.urlAfterRedirects.indexOf("/review") == -1
        ) {
          this.logEvent(
            event.urlAfterRedirects,
            this.utils.getOnboardingData()
          );
        }
        if (
          event.urlAfterRedirects.indexOf("/walkthrough") > -1 ||
          event.urlAfterRedirects.indexOf("/modification") > -1
        ) {
          this.config.isSkip = false;
          this.config.isBack = false;
        }
        console.log("event.urlAfterRedirects", event.urlAfterRedirects);

        if (
          event.urlAfterRedirects.indexOf("/support") > -1 ||
          event.urlAfterRedirects.indexOf("/congrats") > -1
        ) {
          this.config.hideLang = false;
          this.config.isSupport = false;
        }

        if (event.urlAfterRedirects.indexOf("/offline-onboard") > -1) {
          this.config.hideLang = true;
        }
        if (
          event.urlAfterRedirects.indexOf("/onboard-info") > -1 ||
          event.urlAfterRedirects.indexOf("/congrats") > -1 ||
          (event.urlAfterRedirects.indexOf("/open-account") > -1 &&
            this.utils.isMobileDevice())
        ) {
          this.config.isBack = false;
        }
        this.eventURL = event.urlAfterRedirects;
        if (
          (event.urlAfterRedirects.indexOf("/document-uploads") > -1 ||
            event.urlAfterRedirects.indexOf("/nominee-details") > -1) &&
          event.urlAfterRedirects.indexOf("plans") == -1 &&
          event.urlAfterRedirects.indexOf("finalSub") == -1
        ) {
          console.log(this.utils.getTotalSteps());
          this.screenData = this.utils.getTotalSteps();
        } else {
          this.screenData = [];
        }
        //this.screenData=this.utils.getTotalSteps();
      }
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let langQueryParam = params["lang"] || this.utils.getLanguage();
      langQueryParam =
        ["en", "hi"].indexOf(langQueryParam.toLowerCase()) > -1
          ? langQueryParam.toLowerCase()
          : "en"; //(params['lang']) ? params['lang'] : (this.utils.getLanguage()) ? this.utils.getLanguage() : 'en';
      if (langQueryParam != this.utils.selectedLanguage) {
        this.langQueryParam = langQueryParam;
        this.langChange(this.langQueryParam);
      }
      setTimeout(() => {
        document.getElementById("langSelect")["selectedIndex"] =
          langQueryParam == "en" ? 0 : 1;
      }, 500);


     
    });
    // this.shared.sharedScreen$.subscribe(data => {
    //   console.log("sharedData", data)
    // }) 

    document.addEventListener('contextmenu', event => event.preventDefault());
  }

  /**
   * Log event to firebase based on Device
   * @param url url for Page
   * @param data data asscoiated for page
   */
  private logEvent(url: string, data: any) {
    let screen = url.split("/")[3];
    let currentScreen = screen.split("?")[0];
    let screenData = this.utils.config.screens[currentScreen];
    if (screenData) {
      let eventName = screenData.event || screenData.step.event || "onboarding";
      let event: any = {
        screenName:
          (screenData.screenName || screenData.step.screenName) +
          "_" +
          this.utils.businessUnit,
        userId:
          data.id +
          "_" +
          ((data.investorAccountDetailsDtoList || [])[0] || {}).clientID,
        item_category: "screen",
        item_name: screenData.screenName || screenData.step.screenName,
      };
      //Android
      if (
        window["AnalyticsWebInterface"] &&
        window["AnalyticsWebInterface"].logEvent
      ) {
        window["AnalyticsWebInterface"].logEvent(
          eventName,
          JSON.stringify(event)
        );
      } else if (
        window["webkit"] &&
        window["webkit"].messageHandlers &&
        window["webkit"].messageHandlers.firebase
      ) {
        //IOS
        let message = {
          command: "logEvent",
          name: eventName,
          parameters: event,
        };
        window["webkit"].messageHandlers.firebase.postMessage(message);
      } else if (ga) {
        event = {
          eventCategory: eventName,
          eventLabel:
            (screenData.screenName || screenData.step.screenName) +
            "_" +
            this.utils.businessUnit,
          eventAction: "submitted",
          eventValue: data.id || "NA",
          hitCallback: () => {
            console.debug(
              eventName,
              (screenData.screenName || screenData.step.screenName) +
                "_" +
                this.utils.businessUnit
            );
          },
        };
        setTimeout(() => {
          //ga('send', 'event', event);
          window["dataLayer"].push({
            userId: data.id,
          });
        }, 1000);
        setTimeout(() => {
          if (data.lid) {
            window["dataLayer"].push({
              event: "onboarding",
              LeadId: data.lid,
            });
          }
        }, 1000);
      }
    }
  }

  /**
   * Open Skipo Modal before skipping it
   */
  openSkipModal() {
    this.utils.businessUnit;
    this.utils.showModal({
      title: "",
      message:
        "We strongly recommend you to complete it now. But should you decide to quit, we’ll remember where you left and keep reminding you",
      actions: [
        {
          label: "I'll Continue",
          handler: () => {
            this.utils.modalConfig = null;
          },
        },
        {
          label: "Skip It",
          class: "btn-o",
          handler: () => {
            if (this.utils.isMobileDevice()) {
              window.location.href = "assets/skip.html";
            } else {
              window.location = this.utils.getRedirectionURL("loginURL");
            }
            this.utils.modalConfig = null;
          },
        },
      ],
    });
  }

  /**
   * Handler for Back button event
   */
  backHandler() {
    let data = this.utils.getOnboardingData();
    if (
      location.pathname.indexOf("/support") > -1 ||
      location.pathname.indexOf("/recover-account") > -1
    ) {
      history.back();
    } else if (data && data.pannum) {
      let details = this.utils.getAccessList(
        this.utils.getOnboardingData(),
        this.utils.getBusinessUnit()
      );
      let urls = location.pathname.split("/");
      let path = urls[urls.length - 1];
      let lastIndex = details.indexOf(path) > 0 ? details.indexOf(path) - 1 : 0;
      this.route.navigate([
        location.pathname.replace(path, details[lastIndex]),
      ]);
    } else if (location.pathname.indexOf("/congrats") == -1) {
      history.back();
    } else if (location.pathname.indexOf("/congrats") > -1) {
      window.location.href='https://choiceindia.com/open-free-demat-account'
    }
  }
/**
 * On Action base function call
 * @param event The DOM input event triggered by user interaction.
 */
  onActionClicked(event: any) {
    if (event.action == "submit" && event.verified) {
      this.utils.otpFormModal.onSubmit(event);
    } else if (event.action == "cancel") {
      this.utils.otpFormModal.onCancel(event);
      window.location.pathname.indexOf("/open-account") > -1
        ? (this.utils.otpFormModal = null)
        : (this.utils.otpFormModal.isHidden = true);
    } else if (event.action == "skip") {
      if (this.utils.otpFormModal) this.utils.otpFormModal.isHidden = true;
      this.utils.otpFormModal.onSkip(event);
    }
  }
/**
 * Boolean Open Otp modal
 */
  openOtpModal() {
    if (this.utils.otpFormModal) this.utils.otpFormModal.isHidden = false;
  }
/**
 * Store language 
 * @param event The DOM input event triggered by user interaction.
 */
  langChange(event: any) {
    this.langQueryParam = event.target ? event.target["value"] : event;
    this.utils.setLanguage(this.langQueryParam);
    this.utils.getLangData(this.langQueryParam);
    // console.log('set',this.utils.setLanguage(this.langQueryParam))
    // console.log('GET',this.utils.getLangData(this.langQueryParam))
    // this.utils.sendMessage(this.langQueryParam);
  }
/**
 * Check For OTP form
 */
  checkForOTPForm() {
    let otpConfig = this.utils.getOtpConfig();
    if (Object.keys(otpConfig).length) {
      let investor: Investor = this.utils.getOnboardingData();
      let investorDetails: InvestorDetails =
        (investor.investorDetailsDtoList || [])[0] || new InvestorDetails();
      this.utils.showOTPForm({
        isHidden: otpConfig.isHidden,
        formValues: {
          mobileNumber: investorDetails.mobileNum,
          email: investorDetails.emailID,
        },
        isCancel: window.location.pathname.indexOf("/open-account") > -1,
        isSkip: true,
        otpGenerated: otpConfig.otpGenerated,
        onCancel: (event) => {},
        onSkip: (event) => {},
        onSubmit: (event) => {
          if (event.verified) {
            this.utils.updateOnboardingData(event.investor);
            this.utils.updateInvestorDetails(() => {
              this.utils.otpFormModal = null;
            });
          }
        },
      });
    }
  }

  
  /**
   * Dynamically loads an external script by appending a script tag to the document's head.
   * @param url Getting URL
   */
  public loadScript(url) {
    // console.log('preparing to load...')
    let node = document.createElement("script");
    node.src = url;
    node.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(node);
  }
/**
 * Displays a session expiration popup with a custom message and redirect URL.
 * @param {Object} config - Configuration object for the session expiration popup.
 * @param {string} config.message - The message to display in the popup.
 * @param {string} config.url - The URL to redirect to when the user clicks "OK".
 */
  showSessionExpiredPopup(config: {message: string, url: string}) {
    this.utils.showModal({
      title: "Unauthorized Access",
      message: config.message,
      actions: [
        {
          label: "OK",
          handler: () => {
            window.open(
              config.url,
              "_self"
            );
            this.utils.modalConfig = null;
          },
        },
      ],
    });
  }
/**
 * initiate Session Expiry Checker
 */
  initiateSessionExpiryChecker() {
    this.subscription = this.shared.getTokenFailure().subscribe((res) => {
      let sessionModalConfig;
      if(res === 'modification') {
        sessionModalConfig = {
          message: "<p>Your session has been expired, you are being redirected to the login page</p>",
          url: "https://accounts.choiceindia.com/modification/trading/client-login"
        }
      } else if (res === 'raiseIssue'){
        sessionModalConfig = {
          message: "<p>Your session has been expired, you are being redirected to the login page</p>",
          url: "https://accounts.choiceindia.com/onboard/trading/respond-issue"
        }
      } else {
        sessionModalConfig = {
          message: "<p>Your session has been expired. Please click 'OK' and enter your mobile number and OTP on the next page to continue onboarding</p>",
          url: "https://choiceindia.com/open-free-demat-account"
        }
      }
      this.showSessionExpiredPopup(sessionModalConfig);
    });
  }

  gtmtrigger(){
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${''}`;
    document.head.appendChild(gtmScript);

    // Initialize GTM dataLayer
    const dataLayerScript = document.createElement('script');
    dataLayerScript.text = `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
    `;
    document.head.appendChild(dataLayerScript);
  
  }

   private addGoogleTagManagerNoscript(): void {
    const noscript = this.renderer.createElement('noscript');
    const iframe = this.renderer.createElement('iframe');
    
    this.renderer.setAttribute(iframe, 'src', `https://www.googletagmanager.com/ns.html?id=${''}`);
    this.renderer.setAttribute(iframe, 'height', '0');
    this.renderer.setAttribute(iframe, 'width', '0');
    this.renderer.setStyle(iframe, 'display', 'none');
    this.renderer.setStyle(iframe, 'visibility', 'hidden');
    
    this.renderer.appendChild(noscript, iframe);
    this.renderer.appendChild(document.body, noscript);
  }


  private addGoogleAnalyticsScript(): void {
    // Add the main Google Analytics script
    const script = this.renderer.createElement('script');
    script.async = true;
    script.src = 'https://www.google-analytics.com/analytics.js';
    this.renderer.appendChild(document.body, script);
  
    // Add the initialization script
    const inlineScript = this.renderer.createElement('script');
    inlineScript.type = 'text/javascript';
    inlineScript.text = `
      window.ga = window.ga || function () {
        (ga.q = ga.q || []).push(arguments);
      };
      ga.l = +new Date;
      ga('create', 'UA-80424325-2', 'auto', { 'allowLinker': true });
      ga('require', 'linker');
      ga('linker:autoLink', ['investica.com']);
      ga('send', 'pageview');
    `;
    this.renderer.appendChild(document.body, inlineScript);
  }
  



}
